import React, { Component } from 'react'
import { connect } from 'react-redux';
import Service from '../../services';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { BoardsIconInActive, GradesIcon, MailIcon } from '../svgIcons';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../loadingComponent';
import { getBoardsData } from '../../store/actions';
import { baseUrlAdmin } from '../../store/apiConstants';
import { userAssignedBoards } from '../../store/selectors/userAssignedBoards';
import { cloneDeep } from 'lodash';

class BoardToSectionDD extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boardId: null,
            classId: null,
            groupId: null,
            branchId: null,
            classes: [],
            branches: [],
            curriculumInfo: {},
        };
        this.service = new Service()
    }

    componentDidMount() {
        // this.props.getBoardsData(true);
    }

    // Helper method to check if user is a teacher
    isTeacher = () => {
        // Check user type from localStorage
        const userType = localStorage.getItem('type');
        
        // Only if type is 'teacher', check for assignedSubjects
        if (userType === 'teacher') {
            return this.props.userInfo?.assignedSubjects && this.props.userInfo.assignedSubjects.length > 0;
        }
        
        // For all other types (admin, staff, etc.), return false (they get all sections)
        return false;
    }

    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];
        
        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    // Filter boards based on user role
    getFilteredBoards = () => {
        const { userInfo, boards } = this.props;

        // If user is admin, return all boards
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(boards || [], 'boardId');
        }

        // For teachers, filter by assigned boards
        if (this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
            const filteredBoards = boards.filter(board =>
                userInfo?.boardId.includes(board.boardId)
            );
            return this.removeDuplicates(filteredBoards, 'boardId');
        }
        // For non-admin, non-teacher users, filter by assigned boards if available
        else if (!this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
            const filteredBoards = boards.filter(board =>
                userInfo?.boardId.includes(board.boardId)
            );
            return this.removeDuplicates(filteredBoards, 'boardId');
        }

        // Remove duplicate boards by boardId
        return this.removeDuplicates(boards || [], 'boardId');
    }

    // Filter branches based on user's assigned branches
    getFilteredBranches = (branches) => {
        const { userInfo } = this.props;

        // If user is admin, return all branches
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(branches || [], 'branchId');
        }

        // For non-admin users, filter by assigned branches
        if (!userInfo.branchs || userInfo.branchs.length === 0) {
            return this.removeDuplicates(branches || [], 'branchId');
        }

        const filtered = branches.filter(branch =>
            userInfo.branchs.includes(branch.branchId)
        );
        
        return this.removeDuplicates(filtered, 'branchId');
    }

    // Filter sections based on user role and assigned sections
    getFilteredSections = (sections) => {
        const { userInfo } = this.props;

        // If user is admin, return all sections
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(sections || [], 'sectionId');
        }

        // For teachers, filter by assigned sections
        if (this.isTeacher()) {
            // If teacher has no assigned sections, return empty array
            if (!userInfo?.sections || userInfo.sections.length === 0) {
                return [];
            }

            const filtered = sections.filter(section =>
                userInfo.sections.includes(section.sectionId)
            );
            return this.removeDuplicates(filtered, 'sectionId');
        }

        // For non-teacher users, return all sections
        return this.removeDuplicates(sections || [], 'sectionId');
    }



    componentDidUpdate() {

        if (this.state.boardId == null && this.props.boards?.length > 0) {
            const filteredBoards = this.getFilteredBoards();
            
            if (filteredBoards.length > 0) {
                const selectedBoard = filteredBoards.find((board) => board?.boardId === filteredBoards[0]?.boardId);

                if (selectedBoard?.classes?.length > 0) {
                    // Remove duplicate classes
                    const uniqueClasses = this.removeDuplicates(selectedBoard.classes, 'classId');
                    const selectedClass = uniqueClasses.find((classd) => classd.classId == uniqueClasses[0].classId);

                    if (selectedClass?.branches?.length > 0) {
                        // Filter branches based on user assignments
                        const filteredBranches = this.getFilteredBranches(selectedClass.branches);
                        
                        if (filteredBranches.length > 0) {
                            const selectedbranchName = filteredBranches.find((branchd) => branchd.branchId == filteredBranches[0].branchId)?.branchName;

                            const sections = selectedClass.sections?.filter((section) => section.branchId == filteredBranches[0].branchId) || [];
                            
                            // Filter sections based on user role
                            const filteredSections = this.getFilteredSections(sections);

                            const selectedsectionName = filteredSections.length > 0 ? filteredSections.find((sectiond) => sectiond.sectionId == filteredSections[0].sectionId)?.sectionName : '';

                            this.setState({
                                classes: uniqueClasses,
                                boardId: filteredBoards[0]?.boardId,
                                selectedBoardName: selectedBoard.boardName,
                                classId: uniqueClasses[0]?.classId,
                                selectedClass: selectedClass,
                                groupId: selectedClass.groupId,
                                branches: filteredBranches,
                                selectedClassName: selectedClass.className,
                                branchId: filteredBranches[0]?.branchId,
                                selectedbranchName: selectedbranchName,
                                sections: filteredSections,
                                sectionId: filteredSections.length > 0 ? filteredSections[0]?.sectionId : '',
                                selectedsectionName: selectedsectionName,
                            }, () => this.setDropdownsData());
                        }
                    }
                }
            }
        }

    }


    onChangeBoard = (boardId) => {
        this.setState({
            classes: [], classId: null, curriculumInfo: null, branches: [], sections: []
        });
        const filteredBoards = this.getFilteredBoards();
        const selectedBoard = filteredBoards && filteredBoards.find((board) => board?.boardId === boardId);

        // Remove duplicate classes
        const uniqueClasses = this.removeDuplicates(selectedBoard?.classes || [], 'classId');

        this.setState({
            classes: uniqueClasses,
            boardId,
            selectedBoardName: selectedBoard?.boardName,
            classId: '',
            selectedClass: {},
            groupId: '',
            branches: [],
            selectedClassName: ''
        });
    };

    onChangeClass = (classId) => {
        this.setState({
            branches: [], sections: []
        });
        let selectedClass = this.state?.classes?.find((classd) => classd.classId == classId)
        
        // Filter branches based on user assignments
        const filteredBranches = this.getFilteredBranches(selectedClass?.branches);
        
        this.setState({
            classId: classId,
            selectedClass: selectedClass,
            groupId: selectedClass?.groupId,
            branches: filteredBranches,
            selectedClassName: selectedClass?.className,
            branchId: '',
            selectedbranchName: '',
            sections: []
        });
    };

    onChangeBranch = (branchId) => {
        this.setState({
            sections: []
        });
        let selectedbranchName = this.state?.branches?.find((branchd) => branchd.branchId == branchId)?.branchName;
        let sections = this.state.selectedClass?.sections?.filter((section) => section.branchId == branchId)
        
        // Filter sections based on user role
        const filteredSections = this.getFilteredSections(sections);

        this.setState({
            branchId: branchId,
            selectedbranchName: selectedbranchName,
            sections: filteredSections,
            sectionId: '',
            selectedsectionName: '',
        });
    };

    onChangeSection = (sectionId) => {
        let selectedsectionName = this.state.sections?.find((sectiond) => sectiond.sectionId == sectionId).sectionName;

        this.setState({
            sectionId: sectionId,
            selectedsectionName: selectedsectionName,
        }, () => this.setDropdownsData());
    };

    setDropdownsData = () => {
        let {
            boardId,
            classId,
            branchId,
            sectionId,
            selectedBoardName,
            selectedClassName, selectedbranchName, selectedsectionName
        } = this.state
        let returnData = {
            boardId, classId, branchId, sectionId, selectedBoardName,
            selectedClassName, selectedbranchName, selectedsectionName
        }

        this.props.setValues(returnData)
    }



    render() {
        // Get filtered boards for dropdown
        const filteredBoards = this.getFilteredBoards();
        
        return (
            <div>
                <div >
                    <div className='grid m-2'>
                        <div className=" col-3">
                            <ClassetDropdown required={true} label={'Board'}
                                // icon={<MailIcon />}
                                placeholder={'Select Board'} options={filteredBoards} value={this.state?.boardId} onChange={(e) => this.onChangeBoard(e.value)} optionLabel="boardName"
                                optionValue="boardId" disabled={this.props.selectedValue === 2} />
                        </div>
                        <div className=" col-3">
                            <ClassetDropdown required={true} label={'Grade'}
                                // icon={<MailIcon />} 
                                placeholder={'Select Grade'}
                                options={this.state?.classes}
                                value={this.state.classId} onChange={(e) => this.onChangeClass(e.value)} optionLabel="className"
                                optionValue="classId" disabled={this.props.selectedValue === 2} />
                        </div>
                        <div className=" col-3">
                            <ClassetDropdown required={true} label={'Branch'}
                                // icon={<MailIcon />} 
                                placeholder={'Select Branch'} options={this.state?.branches}
                                value={this.state.branchId} onChange={(e) => this.onChangeBranch(e.value)} optionLabel="branchName"
                                optionValue="branchId" disabled={this.props.selectedValue === 2} />
                        </div>
                        <div className=" col-3">
                            <ClassetDropdown required={true} label={'Section'}
                                // icon={<MailIcon />} 
                                placeholder={'Select Section'}
                                options={this.state?.sections}
                                value={this.state.sectionId} onChange={(e) => this.onChangeSection(e.value)} optionLabel="sectionName"
                                optionValue="sectionId" disabled={this.props.selectedValue === 2} />
                        </div>
                    </div>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {this.state.isLoading && <>
                    <LoadingComponent />
                </>}
            </div>
        )
    }
}

const mapStatesToProps = (state) => ({
    // boards: state.boardsData.boards,
    boards: userAssignedBoards(state, 'activeBoards'),
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {},
});
export default connect(mapStatesToProps, { getBoardsData })(BoardToSectionDD);